import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'dateFormat',
  standalone: false
})
export class DateFormatPipe implements PipeTransform {
  transform(date, format: string = 'll, LTS') {
    return date ? moment.utc(date).local().format(format) : "";
  }
}
